<template>
  <div>
    <div>
      <ul>
        <li>
          <img src="/static/img/Naroci/NarociTelevizija/Icon-material-replay.png">
          <span class="open-sans-20pt">
                TV storitve
            </span>
        </li>
      </ul>
    </div>
    <div style="padding-top: 20px">
      <p class="navadno-besedilo">
        Če bi T-2 televizijo radi gledali kjerkoli in kadarkoli, v časovnem zamiku in brez reklam, izberite tv2go
        in časovni zamik. Vsi dogodki preteklega tedna bodo tako z vami ob vsakem koraku.
        <br>
        Preberite več o
        <a :href="povezavaAplikacijaTvGo" class="primarna-barva">
          tv2go
        </a>
        in
        <a :href="povezavaTrikiCasovnihFunkcij" class="primarna-barva">
          časovnih funkcijah</a>.
      </p>
    </div>
    <izdelki-box class="pt-6" v-loading="nalaganjeTvStoritev">
      <izdelek
        v-for="dp in seznamDodatnihPaketov"
        :title="dp.naziv.toUpperCase()"
        :tag="dp.vPaketu === 1 ? 'VKLJUČENO V PAKET' : null"
        :key="dp.idStoritevVrstaIzbira"
      >
        <template v-slot:footer>
          <div class="cena">{{formatPrice(dp.vPaketu === 1 ? 0 : dp.cena)}} / mesec</div>
          <div class="orderButtonContainer">
            <template v-if="dp.vPaketu === 0">
              <OrderButton
                v-if="dp.vklopljeno === 0 && dp.naroceno === 0
                           || dp.vklopljeno === 1 && dp.naroceno === 1"
                :services="[{serviceId: dp.id, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                :service-name="'TV storitev: ' + dp.naziv.toUpperCase()"
                style="width: 170px;"
                @orderConfirmed="$emit('reloadPodatkov')"
              >
                NAROČI STORITEV
              </OrderButton>
              <OrderButton
                v-if="dp.vklopljeno === 1 && dp.naroceno === 0"
                :services="[{serviceId: dp.id, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                :service-name="'TV storitev: ' + dp.naziv.toUpperCase()"
                style="width: 170px;"
                @orderConfirmed="$emit('reloadPodatkov')"
              >
                ODJAVI STORITEV
              </OrderButton>
              <div v-if="dp.vklopljeno === 0 &&
                          dp.naroceno === 1" class="postavitev-gumb-odjavi">
                <a class="okvir-narocilo-v-teku tekst-okvir-narocilo-v-teku">
                  NAROČILO V TEKU
                </a>
              </div>
            </template>
            <template v-else>
              <el-button
                :class="dp.vklopljeno ? 'gumb-crni-okvir' : 'gumb-potrdi'"
                :disabled="dp.naroceno === 1"
                :loading="dp.loading"
                @click="NarociTvStoritve(dp.id, dp.vklopljeno ? 0 : 1, dp.naziv.toUpperCase(), dp)"
              >
                {{dp.vklopljeno ? 'ODJAVI STORITEV' : (dp.naroceno ? 'NAROČILO V TEKU' : 'VKLOPI STORITEV')}}
              </el-button>
            </template>
          </div>
          <div v-if="dp.vPaketu === 1" class="rednaCena">Redna cena: {{formatPrice(dp.cena)}} / mesec</div>
        </template>
        <div class="px-2" style="text-align: justify;">{{dp.opis}}</div>
      </izdelek>
    </izdelki-box>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import {Button, Col} from 'element-ui'
import InfoKomponenta from './InfoKomponenta'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import {SlovenianCurrencyMixin} from '../../../../../assets/js/Helpers/NumberFormatMixin'
import Izdelek from '../../../../UIComponents/Izdelki/Izdelek.vue'
import IzdelkiBox from '../../../../UIComponents/Izdelki/IzdelkiBox.vue'

export default {
  name: 'TVstoritve',
  emits: ['reloadPodatkov'],
  mixins: [SlovenianCurrencyMixin],
  data () {
    return {
      nalaganjeTvStoritev: false,
      seznamPridobljenihPodatkov: [],
      povezavaAplikacijaTvGo: '',
      povezavaTrikiCasovnihFunkcij: ''
    }
  },
  components: {
    IzdelkiBox,
    Izdelek,
    OrderButton,
    InfoKomponenta,
    [Button.name]: Button,
    [Col.name]: Col
  },
  props: {
    izbranPrikljucek: null,
    seznamDodatnihPaketov: null
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.povezavaAplikacijaTvGo = povezave.BASE_URL_MOBILE_APLIKACIJA_T2_TV_GO
    this.povezavaTrikiCasovnihFunkcij = povezave.BASE_URL_TV_CASOVNIH_FUNKCIJ
  },
  methods: {
    NarociTvStoritve (izbranPaketId, status, naziv, dp) {
      dp.loading = true
      this.$emit('narociTvStoritve', izbranPaketId, status, naziv)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVstoritve.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVstoritve.vue